var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricalInstallation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#697580;}.cls-3{fill:#ed6b57;}.cls-4{fill:#f4f5f5;}.cls-5{fill:#f08c7e;}.cls-6{fill:#9d3539;}.cls-7{fill:#a8afbb;}.cls-8{fill:#d2d2d2;}.cls-9{fill:#e0e0e0;}.cls-10{fill:none;mask:url(#mask);}.cls-11{fill:#fff;fill-rule:evenodd;}.cls-12{isolation:isolate;opacity:.3;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 23.68,
    y: 0.03,
    width: 68.11,
    height: 100,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-11",
    points: "23.68 .03 91.79 .03 91.79 100.03 23.68 100.03 23.68 .03"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Electrical_Installation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    className: "cls-12",
    d: "m51.52,99.2c-1.57.79-3.42.78-4.98,0l-35.67-17.99c-2.88-1.44-2.87-5.56.02-6.97l40.61-15.74,36.01,16.22c2.71,1.22,2.79,5.05.13,6.38l-36.13,18.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-9",
    d: "m23.74,30.18v54.29c0,.2,0,.4-.03.6-.09.63-.1,2.85,3.51,4.66,4.25,2.13,20.11,9.86,20.11,9.86,0,0,1.35.96,3.19,0,1.72-.9,32.94-16.69,36.98-18.73.33-.17.64-.38.91-.64.98-.92,3.14-3.27,3.29-6.25.19-3.87,0-59.07,0-59.07,0,0,.19-2.9-2.61-4.35L68.89.5s-1.55-1.06-3.77,0L28.28,18.97s-4.54,1.93-4.54,11.22"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-7",
    d: "m43.32,97.64c-1.85-.9-1.85-3.05-1.84-3.15,0-.5.07-52.97,0-58.48-.07-5.68,4.44-8.41,4.49-8.44l38.46-19.33.61.3-38.8,19.52s-4.26,2.59-4.19,7.94c.07,5.52,0,57.99,0,58.52,0,.05-.18,2.1,1.31,2.83l-.04.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-8",
    d: "m89.44,10.75s-.9-.16-1.96.35c-1.05.51-37.99,19.03-37.99,19.03,0,0-3.92,2.1-3.77,10.22.15,8.12,0,55.69,0,55.69,0,0-.12,2.86,1.61,3.55,0,0,1.37.93,3.19,0,1.82-.93,36.98-18.73,36.98-18.73,0,0,4.03-2.61,4.2-6.89V14.91s.31-2.67-2.26-4.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    className: "cls-2",
    points: "56.12 75.38 69.18 35.14 83.68 61.24 56.12 75.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    className: "cls-5",
    points: "72.01 36.51 70.05 35.57 57 75.81 58.95 76.76 86.51 62.62 72.01 36.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    className: "cls-3",
    points: "58.95 76.76 72.01 36.51 86.51 62.62 58.95 76.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7",
    className: "cls-6",
    points: "72.33 41.33 68.16 57.68 72.33 55.65 72.33 66.89 76.68 50.65 72.42 52.86 72.33 41.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    className: "cls-4",
    points: "73.03 41.71 68.86 58.06 69.9 58.81 73.03 57.29 73.03 67.27 74.07 68.02 78.42 51.78 77.38 51.03 74.15 52.71 74.07 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    className: "cls-1",
    points: "74.07 42.46 69.9 58.81 74.07 56.78 74.07 68.02 78.42 51.78 74.16 53.99 74.07 42.46"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalInstallation);
export default __webpack_public_path__ + "static/media/electrical-installation.592ca62be4e4973e500879b381957482.svg";
export { ForwardRef as ReactComponent };